module.exports = __webpack_public_path__ + "static/media/credit-cards.d5c42c44.svg";